import { API_URL } from "@/http/apiBase";

// Роуты для пользователей
export const USER_ROUTES = Object.freeze({
  LIST: {
    path: "/users",
    name: "user-list",
    title: "Список сотрудников",
  },
  CREATE: {
    path: "/users/new",
    name: "user-create",
    title: "Сотрудник",
  },
  EDIT: {
    path: "/users/:id",
    name: "user-edit",
    title: "Сотрудник",
  },
});

export const API_USER_ENDPOINTS = Object.freeze({
  GET: `${API_URL}/users`,
  GET_BY_ID: (id) => `${API_URL}/users/${id}`,

  CREATE: `${API_URL}/users`,
  UPDATE: (id) => `${API_URL}/users/${id}`,

  DELETE: (id) => `${API_URL}/users/${id}`,
  RESTORE: (id) => `${API_URL}/users/${id}/restore`,
});

export const SORT_TYPES = Object.freeze({
  ASC: "asc",
  DESC: "desc",
});

// NANFin-230: отдел по умолчанию на форме создания сотрудника — №5 «Иные» (id=5).
export const DEFAULT_DEPARTMENT_ID = 5;

export const USERS_FIELDS = Object.freeze({
  ID: "id",
  FIO: "fio",
  NAME: "name",
  TYPE: "type",
  BANNED: "isBanned",
  DEPARTMENT: "department",
});
